import NavElement from "./NavElement";
import { AppParamsContext } from "contexts/AppParamsContext";
import { useContext } from "react";

export default function StartNavElements() {
  const { appParams } = useContext(AppParamsContext);

  let isGrid = ["oneRowScroll", "grid"].includes(
    appParams?.navigation?.startNavSettings?.layout
  );
  let oneRow =
    appParams?.navigation?.startNavSettings?.layout === "oneRowScroll";

  if (
    Object.values(appParams?.navigation?.startNavElementsV2 || {}).length === 0
  )
    return null;

  return (
    <div
      className={`flex ${
        isGrid ? "flex-row" : "flex-col"
      } px-3 pt-2 pb-4 gap-2 w-full ${
        oneRow
          ? "overflow-x-auto overflow-y-hidden shrink-0 items-center"
          : "justify-center flex-wrap"
      }`}
    >
      {Object.values(appParams?.navigation?.startNavElementsV2 || {})
        ?.filter((elem) => elem != null)
        .sort((a, b) => a?.idx - b?.idx)
        .map((element) => (
          <NavElement
            key={element.uuid}
            data={element}
            isGrid={isGrid}
            oneRow={oneRow}
          />
        ))}
    </div>
  );
}
